import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/bmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/bmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/bmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/bmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/bmain/${Id}`);
  },
};
